// extracted by mini-css-extract-plugin
export default {"text":"TariffPollSuccessDialog__text--1oUxs"};